(function () {
  const STORAGE_KEY = 'remmotorcycle_wishlist';
  const DEFAULT_COPY = {
    add: 'Add to favorites',
    remove: 'Remove from favorites',
    title: 'Favorites',
    add_to_cart: 'Add to cart',
    added_to_cart: 'Added to cart',
    sold_out: 'Sold out',
    unavailable: 'Unavailable',
    select_option: 'Choose an option',
    view_product: 'View product',
    add_failed: 'Unable to add to cart',
    empty: 'You have no favorite products yet.',
    continue_shopping: 'Continue shopping'
  };
  const ROOT_URL = ((window.PXUTheme && window.PXUTheme.routes && window.PXUTheme.routes.root_url) || '').replace(/\/$/, '');
  const productDataCache = new Map();
  const productRequestCache = new Map();

  function getCopy() {
    const themeCopy = window.PXUTheme && window.PXUTheme.translation && window.PXUTheme.translation.wishlist;
    return Object.assign({}, DEFAULT_COPY, themeCopy || {});
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/"/g, '&quot;');
  }

  function normalizeImageUrl(url) {
    if (!url) {
      return '';
    }

    if (typeof url === 'object') {
      if (url.src) {
        return normalizeImageUrl(url.src);
      }

      if (url.url) {
        return normalizeImageUrl(url.url);
      }
    }

    if (String(url).startsWith('//')) {
      return 'https:' + url;
    }

    return String(url);
  }

  function getWishlist() {
    try {
      const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(stored)) {
        return [];
      }

      return stored.filter(function (item) {
        return item && (item.handle || item.productId || item.productUrl);
      });
    } catch (error) {
      return [];
    }
  }

  function setWishlist(items) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateHeaderCount();
    syncWishlistButtons(document);
    renderWishlistPages(true);
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: items.length } }));
  }

  function getHandleFromUrl(url) {
    const match = String(url || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function matchesItem(item, payload) {
    if (!item || !payload) {
      return false;
    }

    if (payload.productId && item.productId && String(payload.productId) === String(item.productId)) {
      return true;
    }

    if (payload.handle && item.handle && payload.handle === item.handle) {
      return true;
    }

    return false;
  }

  function findItemIndex(items, payload) {
    return items.findIndex(function (item) {
      return matchesItem(item, payload);
    });
  }

  function buildItem(payload) {
    const productUrl = payload.productUrl || '';

    return {
      productId: payload.productId ? String(payload.productId) : '',
      handle: payload.handle || getHandleFromUrl(productUrl),
      productUrl: productUrl,
      title: payload.productTitle || '',
      productImage: normalizeImageUrl(payload.productImage),
      variantId: payload.variantId ? String(payload.variantId) : '',
      price: payload.price ? String(payload.price) : '',
      compareAtPrice: payload.compareAtPrice ? String(payload.compareAtPrice) : '',
      available: payload.available == null ? '' : String(payload.available),
      variantTitle: payload.variantTitle || '',
      updatedAt: Date.now()
    };
  }

  function updateSavedVariant(payload, variantId, extras) {
    const items = getWishlist();
    const itemIndex = findItemIndex(items, payload);

    if (itemIndex === -1) {
      return;
    }

    items[itemIndex].variantId = String(variantId || '');
    items[itemIndex].updatedAt = Date.now();

    if (extras && extras.productImage) {
      items[itemIndex].productImage = normalizeImageUrl(extras.productImage);
    }

    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    syncWishlistButtons(document);
  }

  function updateHeaderCount() {
    const count = getWishlist().length;

    document.querySelectorAll('[data-wishlist-count]').forEach(function (node) {
      node.textContent = count;
    });
  }

  function buttonPayload(button) {
    return buildItem({
      productId: button.dataset.productId,
      handle: button.dataset.handle,
      productUrl: button.dataset.productUrl,
      productTitle: button.dataset.productTitle,
      productImage: button.dataset.productImage,
      variantId: button.dataset.variantId,
      price: button.dataset.price,
      compareAtPrice: button.dataset.compareAtPrice,
      available: button.dataset.available,
      variantTitle: button.dataset.variantTitle
    });
  }

  function syncWishlistButton(button) {
    const copy = getCopy();
    const payload = buttonPayload(button);
    const isSaved = findItemIndex(getWishlist(), payload) > -1;

    button.classList.toggle('is-active', isSaved);
    button.setAttribute('aria-pressed', String(isSaved));
    button.setAttribute('aria-label', isSaved ? copy.remove : copy.add);
    button.setAttribute('title', isSaved ? copy.remove : copy.add);
  }

  function syncWishlistButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-button]').forEach(syncWishlistButton);
  }

  function toggleWishlist(button) {
    const payload = buttonPayload(button);
    const items = getWishlist();
    const itemIndex = findItemIndex(items, payload);

    if (itemIndex > -1) {
      items.splice(itemIndex, 1);
    } else {
      items.unshift(payload);
    }

    setWishlist(items);
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.PXUTheme.currency.money_format_no_currency || window.PXUTheme.currency.money_format);
    }

    return ((Number(cents) || 0) / 100).toFixed(2);
  }

  function productUrl(product) {
    const url = (product && product.url) ? product.url : '/products/' + product.handle;

    if (ROOT_URL && url.indexOf(ROOT_URL + '/') !== 0) {
      return ROOT_URL + url;
    }

    return url;
  }

  function variantImage(product, variant, savedItem) {
    const source = (variant && variant.featured_image) || savedItem.productImage || product.featured_image || (product.images && product.images[0]);
    return normalizeImageUrl(source);
  }

  function hasOptions(product) {
    return !(product.variants.length === 1 && (product.variants[0].title === 'Default Title' || (product.options.length === 1 && product.options[0] === 'Title')));
  }

  function buildAddToCartButton(label, disabled) {
    return '' +
      '<button type="button" name="add" class="add_to_cart global-button global-button--primary ajax-submit' + (disabled ? ' disabled' : '') + '" data-label="' + escapeAttr(label) + '"' + (disabled ? ' disabled' : '') + '>' +
        '<span class="text">' + escapeHtml(label) + '</span>' +
        '<svg x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" class="checkmark">' +
          '<path fill="none" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"></path>' +
        '</svg>' +
      '</button>';
  }

  function buildVariantOptions(product, selectedVariant) {
    return product.variants.map(function (variant) {
      const compareAt = Number(variant.compare_at_price || 0);
      const image = normalizeImageUrl(variant.featured_image);

      return '' +
        '<option value="' + escapeAttr(variant.id) + '"' +
          (String(variant.id) === String(selectedVariant.id) ? ' selected' : '') +
          ' data-price="' + escapeAttr(variant.price) + '"' +
          ' data-compare-price="' + escapeAttr(compareAt) + '"' +
          ' data-image="' + escapeAttr(image) + '"' +
          ' data-available="' + escapeAttr(variant.available) + '"' +
        '>' + escapeHtml(variant.title) + '</option>';
    }).join('');
  }

  function meaningfulVariantTitle(title) {
    return title && title !== 'Default Title' && title !== 'Title';
  }

  function buildFallbackWishlistCard(savedItem) {
    const copy = getCopy();
    const fallbackUrl = savedItem.productUrl || '/products/' + savedItem.handle;
    const price = Number(savedItem.price || 0);
    const compareAtPrice = Number(savedItem.compareAtPrice || 0);
    const isAvailable = savedItem.available === 'true';
    const hasVariant = Boolean(savedItem.variantId);
    const variantMarkup = meaningfulVariantTitle(savedItem.variantTitle)
      ? '<p class="wishlist-card__variant-label">' + escapeHtml(savedItem.variantTitle) + '</p>'
      : '';
    const actions = hasVariant
      ? '' +
        '<form class="wishlist-card__form">' +
          '<input type="hidden" name="id" value="' + escapeAttr(savedItem.variantId) + '" data-wishlist-variant-id>' +
          '<input type="hidden" name="quantity" value="1">' +
          buildAddToCartButton(isAvailable ? copy.add_to_cart : copy.sold_out, !isAvailable) +
        '</form>'
      : '';

    return '' +
      '<article class="wishlist-card" data-wishlist-card data-handle="' + escapeAttr(savedItem.handle) + '" data-product-id="' + escapeAttr(savedItem.productId) + '">' +
        '<button type="button" class="wishlist-card__remove" data-wishlist-remove data-handle="' + escapeAttr(savedItem.handle) + '" data-product-id="' + escapeAttr(savedItem.productId) + '" aria-label="' + escapeAttr(copy.remove) + '">' + trashIcon() + '</button>' +
        '<a class="wishlist-card__image-link" href="' + escapeAttr(fallbackUrl) + '">' +
          '<img class="wishlist-card__image" data-wishlist-card-image src="' + escapeAttr(normalizeImageUrl(savedItem.productImage)) + '" alt="' + escapeAttr(savedItem.title) + '">' +
        '</a>' +
        '<div class="wishlist-card__body">' +
          '<a class="wishlist-card__title" href="' + escapeAttr(fallbackUrl) + '">' + escapeHtml(savedItem.title) + '</a>' +
          (price ? '<div class="wishlist-card__price" data-wishlist-card-price><span class="wishlist-card__price-current">' + formatMoney(price) + '</span>' + (compareAtPrice > price ? '<span class="wishlist-card__price-compare">' + formatMoney(compareAtPrice) + '</span>' : '') + '</div>' : '') +
          variantMarkup +
          '<div class="wishlist-card__actions">' +
            actions +
            '<a class="secondary_button wishlist-card__view" href="' + escapeAttr(fallbackUrl) + '">' + escapeHtml(copy.view_product) + '</a>' +
          '</div>' +
        '</div>' +
      '</article>';
  }

  function buildWishlistCard(savedItem, product) {
    const copy = getCopy();
    const fallbackUrl = savedItem.productUrl || '/products/' + savedItem.handle;

    if (!product || !Array.isArray(product.variants) || !product.variants.length) {
      return buildFallbackWishlistCard(savedItem);
    }

    const selectedVariant = product.variants.find(function (variant) {
      return String(variant.id) === String(savedItem.variantId);
    }) || product.variants.find(function (variant) {
      return variant.available;
    }) || product.variants[0];

    const currentProductUrl = productUrl(product);
    const currentImage = variantImage(product, selectedVariant, savedItem);
    const compareAtPrice = Number(selectedVariant.compare_at_price || 0);
    const price = Number(selectedVariant.price || 0);
    const variantSelector = hasOptions(product)
      ? '' +
        '<div class="wishlist-card__variant">' +
          '<p class="wishlist-card__variant-label">' + escapeHtml(copy.select_option) + '</p>' +
          '<div class="select wishlist-card__select-wrap">' +
            '<select class="wishlist-card__variant-select" data-wishlist-variant-select>' +
              buildVariantOptions(product, selectedVariant) +
            '</select>' +
          '</div>' +
        '</div>'
      : '';

    if (String(savedItem.variantId || '') !== String(selectedVariant.id)) {
      updateSavedVariant(savedItem, selectedVariant.id, { productImage: currentImage });
    }

    return '' +
      '<article class="wishlist-card" data-wishlist-card data-handle="' + escapeAttr(product.handle) + '" data-product-id="' + escapeAttr(product.id) + '">' +
        '<button type="button" class="wishlist-card__remove" data-wishlist-remove data-handle="' + escapeAttr(product.handle) + '" data-product-id="' + escapeAttr(product.id) + '" aria-label="' + escapeAttr(copy.remove) + '">' + trashIcon() + '</button>' +
        '<a class="wishlist-card__image-link" href="' + escapeAttr(currentProductUrl) + '">' +
          '<img class="wishlist-card__image" data-wishlist-card-image src="' + escapeAttr(currentImage) + '" alt="' + escapeAttr(product.title) + '">' +
        '</a>' +
        '<div class="wishlist-card__body">' +
          '<a class="wishlist-card__title" href="' + escapeAttr(currentProductUrl) + '">' + escapeHtml(product.title) + '</a>' +
          '<div class="wishlist-card__price" data-wishlist-card-price>' +
            '<span class="wishlist-card__price-current">' + formatMoney(price) + '</span>' +
            (compareAtPrice > price ? '<span class="wishlist-card__price-compare">' + formatMoney(compareAtPrice) + '</span>' : '') +
          '</div>' +
          variantSelector +
          '<div class="wishlist-card__actions">' +
            '<form class="wishlist-card__form">' +
              '<input type="hidden" name="id" value="' + escapeAttr(selectedVariant.id) + '" data-wishlist-variant-id>' +
              '<input type="hidden" name="quantity" value="1">' +
              buildAddToCartButton(selectedVariant.available ? copy.add_to_cart : copy.sold_out, !selectedVariant.available) +
            '</form>' +
            '<a class="secondary_button wishlist-card__view" href="' + escapeAttr(currentProductUrl) + '">' + escapeHtml(copy.view_product) + '</a>' +
          '</div>' +
        '</div>' +
      '</article>';
  }

  function emptyWishlistMarkup() {
    const copy = getCopy();
    const allProductsUrl = (window.PXUTheme && window.PXUTheme.routes && window.PXUTheme.routes.all_products_collection_url) || '/collections/all';

    return '' +
      '<div class="wishlist-page__empty">' +
        '<h2>' + escapeHtml(copy.title) + '</h2>' +
        '<p>' + escapeHtml(copy.empty) + '</p>' +
        '<a class="global-button global-button--primary" href="' + escapeAttr(allProductsUrl) + '">' + escapeHtml(copy.continue_shopping) + '</a>' +
      '</div>';
  }

  function wishlistPageMarkup() {
    return '' +
      '<div class="wishlist-page" data-wishlist-page>' +
        '<div class="wishlist-page__header">' +
          '<h1 class="wishlist-page__title">' + escapeHtml(document.title.replace(/\s*-\s*[^-]+$/, '')) + '</h1>' +
        '</div>' +
        '<div class="wishlist-page__content" data-wishlist-content></div>' +
      '</div>';
  }

  function isWishlistPagePath() {
    return /\/pages\/(favorites|favoris)\/?$/.test(window.location.pathname);
  }

  function ensureWishlistPageMount() {
    if (!isWishlistPagePath() || document.querySelector('[data-wishlist-page]')) {
      return;
    }

    const pageColumn = document.querySelector('.container.content.page .one-whole.column');
    const pageContainer = document.querySelector('.container.content.page');
    const target = pageColumn || pageContainer;

    if (!target) {
      return;
    }

    target.innerHTML = wishlistPageMarkup();
  }

  function fetchProductData(handle) {
    if (!handle) {
      return Promise.resolve(null);
    }

    if (productDataCache.has(handle)) {
      return Promise.resolve(productDataCache.get(handle));
    }

    if (productRequestCache.has(handle)) {
      return productRequestCache.get(handle);
    }

    const request = window.fetch(ROOT_URL + '/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Wishlist fetch failed');
        }

        return response.json();
      })
      .then(function (product) {
        if (product) {
          productDataCache.set(handle, product);
        }
        return product;
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        productRequestCache.delete(handle);
      });

    productRequestCache.set(handle, request);
    return request;
  }

  let wishlistRenderToken = 0;

  function renderWishlistPages(force) {
    ensureWishlistPageMount();

    const pages = document.querySelectorAll('[data-wishlist-page]');

    if (!pages.length) {
      return;
    }

    const items = getWishlist();

    pages.forEach(function (page) {
      if (!force && page.dataset.wishlistRendered === 'true') {
        return;
      }

      const content = page.querySelector('[data-wishlist-content]');
      const currentToken = String(++wishlistRenderToken);

      page.dataset.wishlistRenderToken = currentToken;

      if (!content) {
        return;
      }

      if (!items.length) {
        content.innerHTML = emptyWishlistMarkup();
        page.dataset.wishlistRendered = 'true';
        return;
      }

      content.innerHTML = '<div class="wishlist-page__grid">' + items.map(function (item, index) {
        const cachedProduct = item.handle ? productDataCache.get(item.handle) : null;
        return '<div data-wishlist-slot-index="' + index + '">' + buildWishlistCard(item, cachedProduct) + '</div>';
      }).join('') + '</div>';
      page.dataset.wishlistRendered = 'true';

      items.forEach(function (item, index) {
        if (!item.handle || productDataCache.has(item.handle)) {
          return;
        }

        fetchProductData(item.handle).then(function (product) {
          if (!product || page.dataset.wishlistRenderToken !== currentToken) {
            return;
          }

          const slot = page.querySelector('[data-wishlist-slot-index="' + index + '"]');

          if (slot) {
            slot.innerHTML = buildWishlistCard(item, product);
          }
        });
      });
    });
  }

  function trashIcon() {
    return '' +
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
        '<path d="M9 3h6m-9 4h12m-1 0-.75 11.25A2 2 0 0 1 14.26 20H9.74a2 2 0 0 1-1.99-1.75L7 7m3 4v5m4-5v5" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
  }

  function wishlistButtonInner() {
    return '' +
      '<span class="visually-hidden">Add to favorites</span>' +
      '<svg class="wishlist-button__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
        '<path d="M12 21.35 10.55 20.03C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35Z" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
  }

  function injectGloboWishlistButtons(root) {
    (root || document).querySelectorAll('.spf-product-card').forEach(function (card) {
      if (card.querySelector('[data-wishlist-button]')) {
        return;
      }

      const titleLink = card.querySelector('.spf-product-card__title a');
      const imageLink = card.querySelector('.spf-product-card__image-wrapper');
      const variantSelect = card.querySelector('.spf-product__variants');
      const mainImage = card.querySelector('.spf-product-card__image-main') || card.querySelector('.spf-product-card__image');
      const selectedVariant = variantSelect && variantSelect.options[variantSelect.selectedIndex];
      const handle = getHandleFromUrl((titleLink && titleLink.getAttribute('href')) || (imageLink && imageLink.getAttribute('href')) || '');

      if (!imageLink || !handle) {
        return;
      }

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'wishlist-button wishlist-button--card wishlist-button--globo';
      button.setAttribute('data-wishlist-button', '');
      button.innerHTML = wishlistButtonInner();
      button.dataset.handle = handle;
      button.dataset.productUrl = (titleLink && titleLink.getAttribute('href')) || imageLink.getAttribute('href') || '';
      button.dataset.productTitle = titleLink ? titleLink.textContent.trim() : '';
      button.dataset.variantId = selectedVariant ? selectedVariant.value : '';
      button.dataset.productImage = normalizeImageUrl((selectedVariant && selectedVariant.dataset.image) || (mainImage && (mainImage.dataset.src || mainImage.getAttribute('src'))));
      button.dataset.price = selectedVariant ? (selectedVariant.dataset.price || '') : '';
      button.dataset.compareAtPrice = selectedVariant ? (selectedVariant.getAttribute('data-compare_at_price') || selectedVariant.dataset.comparePrice || '0') : '0';
      button.dataset.available = selectedVariant ? (selectedVariant.dataset.available || '') : '';
      button.dataset.variantTitle = selectedVariant ? selectedVariant.textContent.trim() : '';

      card.classList.add('wishlist-ready');
      const inner = card.querySelector('.spf-product-card__inner') || card;
      inner.appendChild(button);
      syncWishlistButton(button);
    });
  }

  function syncProductPageWishlistButton(root) {
    (root || document).querySelectorAll('[data-wishlist-product-page]').forEach(function (button) {
      const productSection = button.closest('.js-product-section--product');

      if (!productSection || productSection.dataset.wishlistBound === 'true') {
        syncWishlistButton(button);
        return;
      }

      const variantSelect = productSection.querySelector('[data-product-form] [data-variants]');

      if (!variantSelect) {
        syncWishlistButton(button);
        return;
      }

      const updateButtonState = function () {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        button.dataset.variantId = selectedOption ? selectedOption.value : '';

        if (selectedOption && selectedOption.dataset.image) {
          button.dataset.productImage = normalizeImageUrl(selectedOption.dataset.image);
        }

        const payload = buttonPayload(button);
        if (findItemIndex(getWishlist(), payload) > -1) {
          updateSavedVariant(payload, button.dataset.variantId, { productImage: button.dataset.productImage });
        }

        syncWishlistButton(button);
      };

      variantSelect.addEventListener('change', updateButtonState);
      productSection.dataset.wishlistBound = 'true';
      updateButtonState();
    });
  }

  function onWishlistRemove(button) {
    const items = getWishlist();
    const payload = {
      productId: button.dataset.productId,
      handle: button.dataset.handle
    };
    const itemIndex = findItemIndex(items, payload);

    if (itemIndex > -1) {
      items.splice(itemIndex, 1);
      setWishlist(items);
    }
  }

  function onWishlistVariantChange(select) {
    const card = select.closest('[data-wishlist-card]');

    if (!card) {
      return;
    }

    const selectedOption = select.options[select.selectedIndex];
    const variantIdInput = card.querySelector('[data-wishlist-variant-id]');
    const image = card.querySelector('[data-wishlist-card-image]');
    const price = card.querySelector('[data-wishlist-card-price]');
    const button = card.querySelector('.add_to_cart');
    const comparePrice = Number(selectedOption.dataset.comparePrice || 0);
    const currentPrice = Number(selectedOption.dataset.price || 0);
    const isAvailable = selectedOption.dataset.available === 'true';
    const copy = getCopy();

    if (variantIdInput) {
      variantIdInput.value = selectedOption.value;
    }

    if (image && selectedOption.dataset.image) {
      image.src = normalizeImageUrl(selectedOption.dataset.image);
    }

    if (price) {
      price.innerHTML = '<span class="wishlist-card__price-current">' + formatMoney(currentPrice) + '</span>' +
        (comparePrice > currentPrice ? '<span class="wishlist-card__price-compare">' + formatMoney(comparePrice) + '</span>' : '');
    }

    if (button) {
      button.disabled = !isAvailable;
      button.classList.toggle('disabled', !isAvailable);
      const text = button.querySelector('.text');
      if (text) {
        text.textContent = isAvailable ? copy.add_to_cart : copy.sold_out;
      }
      button.dataset.label = isAvailable ? copy.add_to_cart : copy.sold_out;
    }

    updateSavedVariant(
      {
        productId: card.dataset.productId,
        handle: card.dataset.handle
      },
      selectedOption.value,
      { productImage: selectedOption.dataset.image }
    );
  }

  function refreshWishlistUI(root) {
    updateHeaderCount();
    syncWishlistButtons(root || document);
    injectGloboWishlistButtons(root || document);
    syncProductPageWishlistButton(root || document);
    renderWishlistPages(false);
  }

  let refreshTimeout = null;

  function scheduleRefresh() {
    window.clearTimeout(refreshTimeout);
    refreshTimeout = window.setTimeout(function () {
      refreshWishlistUI(document);
    }, 80);
  }

  document.addEventListener('click', function (event) {
    const wishlistButton = event.target.closest('[data-wishlist-button]');
    if (wishlistButton) {
      event.preventDefault();
      toggleWishlist(wishlistButton);
      return;
    }

    const removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      onWishlistRemove(removeButton);
    }
  });

  document.addEventListener('change', function (event) {
    const globoVariantSelect = event.target.closest('.spf-product__variants');
    if (globoVariantSelect) {
      const card = globoVariantSelect.closest('.spf-product-card');
      const button = card && card.querySelector('[data-wishlist-button]');
      const selectedOption = globoVariantSelect.options[globoVariantSelect.selectedIndex];
      const image = card && (card.querySelector('.spf-product-card__image-main') || card.querySelector('.spf-product-card__image'));

      if (button && selectedOption) {
        button.dataset.variantId = selectedOption.value;
        button.dataset.productImage = normalizeImageUrl(selectedOption.dataset.image || (image && (image.dataset.src || image.getAttribute('src'))));
        button.dataset.price = selectedOption.dataset.price || '';
        button.dataset.compareAtPrice = selectedOption.getAttribute('data-compare_at_price') || selectedOption.dataset.comparePrice || '0';
        button.dataset.available = selectedOption.dataset.available || '';
        button.dataset.variantTitle = selectedOption.textContent.trim();
        const payload = buttonPayload(button);
        if (findItemIndex(getWishlist(), payload) > -1) {
          updateSavedVariant(payload, selectedOption.value, { productImage: button.dataset.productImage });
        }
        syncWishlistButton(button);
      }
      return;
    }

    const wishlistVariantSelect = event.target.closest('[data-wishlist-variant-select]');
    if (wishlistVariantSelect) {
      onWishlistVariantChange(wishlistVariantSelect);
    }
  });

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) {
      refreshWishlistUI(document);
      renderWishlistPages(true);
    }
  });

  window.addEventListener('globoFilterRenderCompleted', function () {
    scheduleRefresh();
  });

  document.addEventListener('wishlist:updated', function () {
    renderWishlistPages(true);
  });

  const bodyObserver = new MutationObserver(function () {
    scheduleRefresh();
  });

  function initWishlist() {
    ensureWishlistPageMount();
    refreshWishlistUI(document);
    renderWishlistPages(true);

    if (document.body) {
      bodyObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlist);
  } else {
    initWishlist();
  }
})();
